import React, { useEffect, useState } from "react";

const COLORS = ["#f7a600", "#e8590c", "#1fb141", "#2ecc71", "#5cabff", "#ffb911", "#ff6b6b", "#cbb6ff"];

// Confettis légers (CSS, sans dépendance) — célébration d'obtention de badge.
const Confetti = ({ pieces = 90, duration = 3200, onDone }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setShow(false);
      if (onDone) onDone();
    }, duration);
    return () => clearTimeout(t);
  }, [duration, onDone]);

  if (!show) return null;

  const items = Array.from({ length: pieces }, (_, i) => {
    const left = Math.random() * 100;
    const delay = Math.random() * 0.6;
    const dur = 2.2 + Math.random() * 1.6;
    const size = 6 + Math.random() * 7;
    return (
      <span
        key={i}
        className="confetti-piece"
        style={{
          left: `${left}%`,
          background: COLORS[i % COLORS.length],
          width: `${size}px`,
          height: `${size * 0.55}px`,
          animationDelay: `${delay}s`,
          animationDuration: `${dur}s`,
        }}
      />
    );
  });

  return <div className="confetti-overlay">{items}</div>;
};

export default Confetti;
